export default __webpack_public_path__ + "static/media/robot.bb183b6d.png";